import * as React from 'react';
import Result from "./Result";
import { VolumetricParameter, FlowParameter, DiffusingCapacityParameter, PressureParameter } from './PFTAPITypes';
export interface CvResultProps {
    result: VolumetricParameter | FlowParameter | DiffusingCapacityParameter | PressureParameter;
    isLoading?: boolean;
}
export const CvResult = ({ result, isLoading }: CvResultProps) =>
{
    return (
        <td data-automationid={`cv-result-${result.ParameterType}`}>
            <Result isLoading={isLoading} parameter={result} />
        </td>
    );
}
